import {listBancos, removeBanco} from '@/domain/cadastro/services'
import window from './window/window.js'

export default {
  pageTitle: 'Bancos',
  columns: [
    {
      name: 'nome',
      required: true,
      label: 'Nome',
      align: 'left',
      field: 'nome',
      sortable: true,
      parser: function (props) {
        return props.nome
      }
    },
    {
      name: 'codigo',
      required: true,
      label: 'Código',
      align: 'left',
      field: 'codigo',
      sortable: true,
      parser: function (props) {
        return props.codigoBanco
      }
    },
    {
      name: 'conta',
      required: true,
      label: 'Agência / Conta',
      align: 'left',
      field: 'conta',
      sortable: true,
      parser: function (props) {
        return `${props.agencia} / ${props.conta}`
      }
    },
    {
      name: 'active',
      required: true,
      label: 'Situação',
      align: 'left',
      field: 'active',
      sortable: true,
      parser: function (props) {
        return props.active ? 'Ativo' : 'Inativo'
      }
    },
    {
      name: 'options',
      required: true,
      label: '',
      field: 'options',
      sortable: false
    }
  ],
  resolve: listBancos,
  methods: {
    // window: window
    abrir: function (id) {
      window.call(this, {id: id, table: this.table})
    },
    novo: function () {
      window.call(this, {})
    },
    excluir: removeBanco
  }
}
